/// <amd-module name="Wit/BoardsHub/KanbanBoard/Utils/BoardEditPermissionContext" />

import * as React from "react";

interface IBoardEditPermissionContext {
    hasBoardEditPermission: boolean;
}

export const BoardEditPermissionContext = React.createContext<IBoardEditPermissionContext>({
    hasBoardEditPermission: false
});

interface IBoardEditPermissionProviderProps {
    hasBoardEditPermission: boolean;
}

export const BoardEditPermissionProvider: React.FunctionComponent<IBoardEditPermissionProviderProps> = ({ children, hasBoardEditPermission }) => {
    return <BoardEditPermissionContext.Provider value={{ hasBoardEditPermission }}>{children}</BoardEditPermissionContext.Provider>;
};

export function useBoardEditPermission(): boolean {
    return React.useContext(BoardEditPermissionContext).hasBoardEditPermission;
}
